module.exports = __webpack_public_path__ + "static/media/logo-dtn.0d68ad62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-dtn.svg
// module id = 228
// module chunks = 0